<template>
  <div>
    <breadcrumbs :home="caskName + ': Set age'"/>

      <v-card flat>
        <v-form v-model="valid" ref="form" :disabled="!edit">
          <v-container class="pt-6 px-6 purtrak-scrollable" fluid>

            <v-row dense>
              <v-col cols="6" sm="4" lg="3">
                <date-picker v-model="transaction.date" @change="refresh()"/>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="6" sm="2">
                <decimal-number-input label="Age" v-model="transaction.age" prefix=""
                                      :suffix="period" :precision="period==='days'?0:1"/>
              </v-col>
              <v-col cols="3" sm="1">
                <v-switch v-model="period" label="Days" hide-details class="mt-1 ml-1" false-value="years" true-value="days"
                        @change="transaction.age = period === 'days' ? Math.round(transaction.age * 365) : Math.round(transaction.age / 365 * 10)/10"/>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field label="Comments" v-model="transaction.comments" outlined dense counter="255" :rules="[fieldRules.maxLength(255)]"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <v-divider/>
        <v-card-actions class="px-6">
          <template v-if="transactionId && company.permissions.includes('production.write')">
            <v-switch :disabled="dirty"
                      v-model="edit" label="Edit" hide-details class="mt-0"/>
          </template>
          <v-spacer/>
          <v-btn :plain="edit" color="primary" @click="cancel">{{edit?'Cancel':'Done'}}</v-btn>
          <v-btn v-if="edit" color="primary" :loading="saving" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>

    <confirm-leave v-model="next"/>
  </div>

</template>

<script>
import {format} from 'date-fns'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'InventoryCasksSetAge',
  mixins: [confirmLeave],
	props: {
    caskId: {type:String,required:false},
    transactionId: {type:String, required:false}
	},
	data() {
		return {
      edit: false,
      caskName: '',
      valid:true,
      saving:false,
      transaction: {caskId:this.caskId, date: format(new Date(), 'yyyy-MM-dd HH:mm:ss'), age:0, comments: ''},
      period: 'days',
      dirty: false
		}
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
  },
  watch: {
    transaction: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },
	async created() {
    if (this.transactionId) {
      const results = await this.$apiCall(`query InventoryCasksSetAge($id:ID!) {
                                            caskSetAge(id:$id) {
                                              id,caskId,date,age,comments
                                            }
                                          }`,
                                          {id:this.transactionId});
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      this.transaction = results.data.caskSetAge;
    }
    else
      this.edit = true;
    this.refresh();
    this.$nextTick(() => this.dirty = false);
  },

	methods: {
    async refresh() {
      if (this.caskName && this.transactionId)
        return;
      const results = await this.$apiCall(`query InventoryCasksSetAge($caskId:ID!, $asof:DateTime) {
                                            cask(id:$caskId) {
                                              name,daysOld(asof:$asof)
                                            }
                                          }`,
                                          {caskId:this.caskId??this.transaction.caskId, asof:this.transaction.date});
      if (!results.error) {
        this.caskName = results.data.cask.name;
        if (!this.transactionId)
          this.transaction.age = results.data.cask.daysOld;
      }
    },
    cancel() {
      this.$router.back();
    },
		async save() {
      if (this.valid) {
        this.saving = true;
        const {...input} = this.transaction;
        input.age = this.period === 'days' ? input.age : input.age * 365;
        const results = await this.$apiCall(`mutation InventoryCasksSetAge($input: CaskSetAgeInput!) {
                                                caskSetAgeCreate(input:$input) {id}
                                              }`,
                                            {input});
        this.saving = false;
        if (!results.error) {
          this.dirty = false;
          this.$router.back();
          this.$store.commit('setError', {type:'success',message:`${this.transactionId?'Updated':'Created'} set cask age transaction for ${this.caskName}`});
        }
      }
		}
	}
}
</script>